import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { NavigationCollectionsRemote } from '@atlassian/jira-polaris-component-navigation-collections-store/src/common/types/remote.tsx';
import { fetchAllCollections } from '@atlassian/jira-polaris-component-collections/src/services/collections/index.tsx';

export const createNavigationCollectionsRemote = (
	_: CreateUIAnalyticsEvent,
): NavigationCollectionsRemote => ({
	fetch: () => fetchAllCollections(),
});
